export default `
query getCategoryBreadcrumb($uid: String!) {
	categoryList(filters: {category_uid: {eq: $uid}}) {
		uid
		level
		url_path
		name
		breadcrumbs {
			category_uid
			category_name
			category_level
			category_url_path
		}
	}
}`;

export declare type maybe<T> = T | null;

export interface CategoryBreadcrumbInterface {
  category_uid?: maybe<string>;
  category_name?: maybe<string>;
  category_level?: maybe<number>;
  category_url_path?: maybe<string>;
}
export interface CategoryBreadcrumbQueryResponseInterface {
  categoryList: {
    uid?: maybe<string>;
    level?: maybe<number>;
    name?: maybe<string>;
    url_path?: maybe<string>;
    breadcrumbs?: maybe<Array<CategoryBreadcrumbInterface>>;
  };
}
